// extracted by mini-css-extract-plugin
export var sliderRange = "_n5-2";
export var sliderRoot = "_n5-0";
export var sliderThumb = "_n5-3";
export var sliderTrack = "_n5-1";